import { Color, DefaultValue, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

interface ShortcutKeyWrapperProps {
  wide?: boolean
}

export const ShortcutKeyWrapper = styled.span<ShortcutKeyWrapperProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: ${Spacing.S4} ${({ wide }) => (wide ? Spacing.S8 : Spacing.S4)};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${Color.Grey150};

  & + & {
    margin-left: ${Spacing.S2};
  }
`
